import useParamsType from 'src/hooks/useParamsType.hook'
import PaymentFinishPageView from 'src/pages/PaymentFinishPage/view'

export interface PaymentFinishPageProps {
  handleCloseButton: () => void
  isHotDeal: boolean
}

const PaymentFinishPage = () => {
  const { pay_channel, couponType } = useParamsType()

  const isHotDeal = couponType === '1'

  const handleCloseButton = () => {
    switch (pay_channel) {
      case 'ios':
      case 'aos':
        window.location.href = 'couponwalletapp://payment_return'
        break
      case 'web':
      default:
        window.open('', '_self', '')
        window.close()
        break
    }
  }

  const props: PaymentFinishPageProps = {
    handleCloseButton,
    isHotDeal,
  }

  return <PaymentFinishPageView {...props} />
}
export default PaymentFinishPage
